function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata5"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-275.83332)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("g", {
  id: "g877"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect836",
  d: "M 5.780128,278.74664 H 9.0365384 V 281.596 H 5.780128 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "rect836-3",
  d: "m 4.1519227,276.97308 h 6.5128203 v 2.38416 H 4.1519227 Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "path853-6",
  d: "m 7.859375,287.69336 a 0.53138491,0.53138491 0 1 0 0,1.0625 h 3.896484 a 0.53138491,0.53138491 0 1 0 0,-1.0625 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path853-67",
  d: "m 7.5956584,280.69688 c -3.9752529,0 -7.20881721,3.23174 -7.20881814,7.207 -3.73e-6,3.97526 3.23356154,7.20882 7.20881814,7.20882 3.9752576,0 7.2070026,-3.23356 7.2069986,-7.20882 0,-3.97526 -3.231746,-7.207 -7.2069986,-7.207 z m 0,0.98409 c 3.4425566,0 6.2229026,2.78035 6.2229036,6.22291 3e-6,3.44256 -2.780343,6.2229 -6.2229036,6.2229 -3.4425598,0 -6.2229071,-2.78034 -6.2229034,-6.2229 9e-7,-3.44256 2.7803464,-6.22291 6.2229034,-6.22291 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path896",
  d: "m 11.318359,283.69922 a 0.52921956,0.52921956 0 0 0 -0.363281,0.16016 l -4.1542968,4.15429 a 0.52921956,0.52921956 0 1 0 0.7480469,0.74805 l 4.1542969,-4.1543 a 0.52921956,0.52921956 0 0 0 -0.384766,-0.9082 z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7",
  d: "m 21.134064,13.931019 c -1.329109,0 -2.574366,-0.66855 -3.262333,-1.796272 -0.687967,-1.127722 -0.687967,-2.5537068 0,-3.6814286 0.687967,-1.127722 1.933224,-1.796273 3.262333,-1.796273 v 2.140438 c -0.608762,0 -1.154601,0.309927 -1.435571,0.7704948 -0.280969,0.4605698 -0.280969,0.9915398 0,1.4521078 0.28097,0.460568 0.826809,0.770496 1.435571,0.770496 z"
}), /*#__PURE__*/React.createElement("rect", {
  ry: 9.5216132e-7,
  y: 9.1767874,
  x: 14.860898,
  height: 2.0670574,
  width: 2.7717056,
  id: "rect962"
}));

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 21.166666 21.166667",
    height: 80,
    width: 80,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.6c81d06c.svg";
export { ForwardRef as ReactComponent };